import AdminNewBooksPage from './AdminNewBooksPage'
export default AdminNewBooksPage;